 <div>
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Alert!</h5>
          <!-- <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button> -->
        </div>
        <div class="modal-body text-center">
         {{data.message}}
        </div>
        <div class="modal-footer d-block mx-auto">
          <button  (click)="delete()" type="button" class="btn btn-primary" data-dismiss="modal">Yes</button>
          <button  (click)="continue()" type="button" class="btn btn-cancel" data-dismiss="modal">No</button>
        </div>
      </div>
    </div>